import { companySchema } from './general.schema.js'

export const createCompanySchema = companySchema.omit([
  'id',
  'useOurWebsiteApplicationForm',
  'applicationLink',
  'notificationAboutNewBoard'
])

const createCompanyFront = [
  createCompanySchema.pick([
    'name',
    'url',
    'dot',
    'addressHQ'
  ]).objectRequired(),

  createCompanySchema.pick([
    'locationQuantity',
    'employeesQuantity',
    'CDLDriversQuantity'
  ]).objectRequired(),

  createCompanySchema.pick([
    'formalTrainingProcess',
    'hireWithExperience',
    'minimumDUITime',
    'maximumDUIInLife',
    'hireWithFelonies',
    'makeOfTractors'
  ]).objectRequired(),

  createCompanySchema.pick([
    'union',
    'healthInsurance',
    'healthInsuranceForEmployee',
    'healthInsuranceForFamily',
    'healthInsuranceEligableAfter'
  ]).objectRequired(),

  createCompanySchema.pick([
    'dentalInsurance',
    'dentalInsuranceForEmployee',
    'dentalInsuranceForFamily',
    'dentalInsuranceEligableAfter',
    'visionInsurance',
    'visionInsuranceForEmployee',
    'visionInsuranceForFamily',
    'visionInsuranceEligableAfter'
  ]).objectRequired(),

  createCompanySchema.pick([
    'retirementPlan',
    'paidHolidays',
    'numberOfPaidHolidays',
    'paidVacation',
    'vacation'
  ]).objectRequired(),

  createCompanySchema.pick([
    'bonuses',
    'bonusesTypes',
    'passengersAllowed',
    'passengersTypes',
    'petsAllowed',
    'petsTypes'
  ]).objectRequired()
]

export const createCompanySchemas = {
  front: createCompanyFront,
  back: createCompanySchema
}
